// extracted by mini-css-extract-plugin
export var active = "_l8-2";
export var recordingDot = "_l8-1";
export var recordingIndicator = "_l8-0";